export default {
    text_1: "Štatistiky",
    text_2: "Zaujímajú ťa čísla? Na tomto mieste nájdeš to najdôležitejšie.",
    text_3: "Základné údaje",
    text_4: "Hodnota ponúk tento mesiac",
    text_5: "Celková hodnota ponúk",
    text_6: "Počet klientov",
    text_7: "Hodnota tvojich ponúk",
    text_8: "Počet tvojich ponúk",
    text_9: "Moji používatelia",
    text_10: "Využívajú DOFFERO aj tvoji zamestnanci alebo kolegovia? Tu uvidíš štatistiky svojich používateľov. Tieto štatistiky vidíš len ty.",
    text_11: "Aktuálne nemáš pridaných žiadnych používateľov.",
    text_12: "Pridať používateľa",
    text_13: "počet ponúk",
    text_14: "hodnota spolu",
    text_15: "Meno",
    text_16: "Celkom:",
    text_18: "Celková",
    text_19: "Podľa stavov",
    text_20: "Graf je možné filtrovať podľa stavov ponúk, stačí kliknúť na konkrétny stav v legende grafu.",

    january: "Január",
    february: "Február",
    march: "Marec",
    april: "Apríl",
    may: "Máj",
    june: "Jún",
    july: "Júl",
    august: "August",
    september: "September",
    october: "Október",
    november: "November",
    december: "December",

    graph_text1: " ponúk",
    graph_text2: " ponuka",
    graph_text3: " ponuky",
    graph_text4: " používateľ",
    graph_text5: " používateľov",

    graph_text6: " emailov",
    graph_text7: " email",
    graph_text8: " emaily",

}